export const WHITE_LABEL_COLORS = {
    primary: "#D20071",
    secondary: "#4A148C",
    tertiary: "#5BC6CC",
    quaternary: "#FADE5B",
    error: "#D00416",
    neutral1: "#F8F6FA",
    neutral2: "#F0EBF5",
    eggShell: "#F7F7F7",
    white: "#FFFFFF",
} as const;
